import React from 'react';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import RefreshIcon from "@mui/icons-material/Refresh";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LastRefreshTimer from './LastRefreshTimer';
import { keyframes } from '@emotion/react';

const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const ACCENT = '#3399cd';

const Dashboard = ({
    householdData = {},
    lastRefreshAt = null,
    loaderCommission = false,
    onRefresh = () => {},
}) => {
    const formatMoney = (value) => (value || value === 0 ? `$${value}` : '-');
    const displayStat = (val) => {
        if (val === undefined || val === null) return "-";
        if (val === 0) return "0";
        return val;
    };

    const styles = {
        page: { backgroundColor: '#dfe3e9', minHeight: 'calc(100vh - 265px)', padding: '25px 18px 20px', display: 'flex', alignItems: 'stretch', alignContent: 'flex-start', gap: 32, flexWrap: 'wrap', fontFamily: 'Roboto, Arial, sans-serif' },
        welcome: { flex: '0 0 auto', whiteSpace: 'nowrap', boxSizing: 'border-box', padding: '15px', borderRadius: 6, backgroundColor: '#5f7186', color: '#fff', fontSize: 20, lineHeight: 1.3, fontWeight: 400, boxShadow: '0 3px 8px rgba(0,0,0,0.18)' },
        card: { flex: '1 1 480px', boxSizing: 'border-box', padding: '16px 18px 20px', borderRadius: 4, backgroundColor: '#fff', boxShadow: '0 3px 8px rgba(0,0,0,0.12)' },
        cardHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 },
        title: { fontSize: 18, fontWeight: 500, color: '#555', minWidth: 150 },
        refresh: { display: 'flex', alignItems: 'center', fontStyle: 'italic', fontSize: 13, color: '#7a7a7a' },
        refreshBtn: { border: 'none', background: 'transparent', padding: 4, marginLeft: 6, cursor: 'pointer', color: '#1a2c40', display: 'flex' },
        groups: { display: 'flex', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 20 },
        group: { display: 'flex', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 14, flex: '1 1 0', minWidth: 0 },
        icon: { fontSize: 28, color: ACCENT, marginTop: 2, flexShrink: 0 },
        stat: { flex: '1 1 0', minWidth: 0 },
        value: { fontSize: 22, fontWeight: 500, color: '#333', lineHeight: 1.2 },
        label: { fontSize: 14, color: '#6a6b73', lineHeight: 1.25, marginTop: 4 },
    };

    const Stat = ({ value, label, grow = 1 }) => (
        <div style={{ ...styles.stat, flex: `${grow} 1 0` }}>
            <div style={styles.value}>{value}</div>
            <div style={styles.label}>{label}</div>
        </div>
    );

    return (
        <div style={styles.page}>
            <div style={styles.welcome}>Thanks for being part of the Vera<br />Team.</div>

            <div style={styles.card}>
                <div style={styles.cardHeader}>
                    <Select
                        value="toDate"
                        disableUnderline
                        style={styles.title}
                        MenuProps={{ getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } }}
                        inputProps={{ 'aria-label': 'Period' }}
                    >
                        <MenuItem value="toDate" style={{ fontSize: 16 }}>To Date</MenuItem>
                    </Select>
                    <div style={styles.refresh}>
                        <span>Last Refresh:&nbsp;&nbsp;<LastRefreshTimer lastRefreshAt={lastRefreshAt} /></span>
                        <button type="button" aria-label="Refresh" style={styles.refreshBtn} onClick={() => (loaderCommission ? {} : onRefresh())}>
                            <RefreshIcon sx={{
                                fontSize: 28,
                                animation: loaderCommission ? `${spin} 1s linear infinite` : 'none',
                                transformOrigin: 'center',
                            }} />
                        </button>
                    </div>
                </div>

                <div style={styles.groups}>
                    <PeopleAltIcon style={styles.icon} />
                    <Stat value={displayStat(householdData.prospectCount)} label="In-Progress Enrollments" />
                    <Stat value={displayStat(householdData.enrollCount)} label="Completed Enrollments" />
                    <Stat value={displayStat(householdData.activeCount)} label="Active Members" />
                    <Stat value={displayStat(householdData.terminatedCount)} label="Terminated Members" />
                    <AttachMoneyIcon style={{ ...styles.icon, marginLeft: 32 }} />
                    <Stat grow={1.4} value={formatMoney(householdData.prospectedAmount)} label="Total Monthly Premium Prospected" />
                    <Stat grow={1.4} value={formatMoney(householdData.enrollAmount)} label="Total Monthly Premium Enrolled" />
                    <Stat grow={1.4} value={formatMoney(householdData.notEnrollAmount)} label="Total Monthly Premium In Progress" />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
